import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgWheelchair = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.625 5.125C7.625 5.78804 7.88839 6.42393 8.35723 6.89277C8.82607 7.36161 9.46196 7.625 10.125 7.625C10.788 7.625 11.4239 7.36161 11.8928 6.89277C12.3616 6.42393 12.625 5.78804 12.625 5.125C12.625 4.46196 12.3616 3.82607 11.8928 3.35723C11.4239 2.88839 10.788 2.625 10.125 2.625C9.46196 2.625 8.82607 2.88839 8.35723 3.35723C7.88839 3.82607 7.625 4.46196 7.625 5.125V5.125Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.125 7.625V13.875C10.125 14.2065 10.2567 14.5245 10.4911 14.7589C10.7255 14.9933 11.0435 15.125 11.375 15.125H15.125C15.788 15.125 16.4239 15.3884 16.8928 15.8572C17.3616 16.3261 17.625 16.962 17.625 17.625V21.375H18.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.125 11.375H10.125C9.1361 11.375 8.1694 11.6682 7.34715 12.2177C6.52491 12.7671 5.88404 13.548 5.5056 14.4616C5.12717 15.3752 5.02815 16.3805 5.22108 17.3505C5.414 18.3204 5.89021 19.2113 6.58947 19.9105C7.28873 20.6098 8.17965 21.086 9.14955 21.2789C10.1195 21.4719 11.1248 21.3728 12.0384 20.9944C12.952 20.616 13.7329 19.9751 14.2823 19.1529C14.8318 18.3306 15.125 17.3639 15.125 16.375V15.125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgWheelchair.displayName = 'SvgWheelchair';
export default SvgWheelchair;
